import React, { useContext } from 'react';
import '../../css/select.css';
import { functionContext } from '../../App';

function Select() {

  const { selectedWord } = useContext(functionContext);
  const displayWord = selectedWord || 'Tap a card to select a word';

  return (
    <>
      <div id="select">
        <p className="select-label">{displayWord}</p>
      </div>
    </>
  )
}

export default Select;
